import React from 'react';

import { EMPTY_FIELD } from 'support/helpers/const/const';
import { Button, ButtonType } from 'components/Form/Button/Button';

type FileRowAction = Pick<ButtonType, 'onClick' | 'disabled' | 'loading' | 'LeftIcon' | 'RightIcon'> &
  Partial<Pick<ButtonType, 'analyticsId'>> & {
    label: string;
  };

type FileRowProps = {
  icon: React.ComponentType<any>;
  text: string;
  action?: FileRowAction;
  label?: string;
  description?: string;
};

export const FileRow = ({ icon: Icon, text, action, label, description }: FileRowProps) => (
  <div className="flex flex-col gap-2">
    {label && <span className="text-xs text-gray-500">{label}</span>}
    {description && <p className="text-sm text-gray-500">{description}</p>}
    {text ? (
      <div className="flex items-center justify-between rounded-md bg-gray-50 p-4">
        <div className="flex items-center gap-3">
          <Icon className="size-5 shrink-0 text-gray-500" />
          <span className="text-sm font-semibold text-gray-700">{text}</span>
        </div>
        {action && (
          <Button
            variant="secondary"
            size="extra-small"
            onClick={action.onClick}
            disabled={action.disabled}
            loading={action.loading}
            LeftIcon={action.LeftIcon}
            RightIcon={action.RightIcon}
            analyticsId={action.analyticsId ?? ''}
          >
            {action.label}
          </Button>
        )}
      </div>
    ) : (
      <span className="text-sm text-gray-400">{EMPTY_FIELD}</span>
    )}
  </div>
);

export type { FileRowAction };
